import { StyledSpecialist } from '@/components/styles';
import { ActiveLink, Picture } from '@/components';
import genLinkParams from '@/lib/generateLinkParams';
import Icon from '@/assets/icons';

export default function Specialist(props) {
  const {
    id,
    preview: imageFromProps,
    preview_alt,
    position,
    qualification,
    slug,
    first_name: firstName,
    last_name: lastName,
    patronymic,
    ...otherProps
  } = props;

  const [href, as] = genLinkParams({ type: 'specialist', slug });
  const image = imageFromProps || {};
  const title = `${lastName} ${firstName}${patronymic ? ' ' + patronymic : ''}`;
  const imageAlt = preview_alt || title || '';

  return (
    <StyledSpecialist {...otherProps}>
      <ActiveLink href={href} as={as} addHrefActive={true} activeAs={'a'}>
        <StyledSpecialist.Link />
      </ActiveLink>

      <StyledSpecialist.Bg>{/* <StyledSpecialist.Circle /> */}</StyledSpecialist.Bg>

      <StyledSpecialist.Img>{Object.keys(image).length > 0 && <Picture {...image} alt={imageAlt} isLazy={true}/>}</StyledSpecialist.Img>

      <StyledSpecialist.Arrow>
        <Icon name="arrow-right" />
      </StyledSpecialist.Arrow>

      <StyledSpecialist.Content>
        <StyledSpecialist.Title>{title}</StyledSpecialist.Title>

        {position && <StyledSpecialist.Qualification>{position}</StyledSpecialist.Qualification>}
      </StyledSpecialist.Content>
    </StyledSpecialist>
  );
}
